import { ReactNode } from "react";
import { View } from "react-native";
import { usePlatformSafeAreaInsets, useKeyboard } from "../hooks";

import ErrorMessage from "./ErrorMessage";

type HorizontalOption = "all" | "web" | "default" | "webLeft";

type Props = {
  children: ReactNode;
  errorTitle?: string;
  errorAlert?: boolean;
  errorMessage?: string;
  hideBorder?: boolean;
  horizontalStyle?: HorizontalOption;
  onCloseErrorMessage?: React.Dispatch<React.SetStateAction<string>>;
  insideModal?: boolean;
};

const horizontalStyles = {
  all: "flex-row justify-between",
  web: "web:flex-row-reverse justify-between",
  default: "sm:items-start sm:flex-row",
  webLeft: "web:flex-row-reverse justify-end",
};

export default function ActionsContainer({
  children,
  errorAlert,
  errorMessage,
  errorTitle,
  onCloseErrorMessage,
  hideBorder = false,
  horizontalStyle = "default",
  insideModal,
}: Props) {
  const insets = usePlatformSafeAreaInsets(insideModal ? 0 : 40);
  const { isKeyboardVisible } = useKeyboard();
  const marginBottom = isKeyboardVisible ? 0 : insets.bottom / 2;
  const verticalPadding = insideModal ? "sm:py-8" : "sm:pt-8";

  return (
    // Add negative margin so border goes all across ScreenContainer
    <View className="sm:-mx-8">
      {!!errorMessage && onCloseErrorMessage && (
        <ErrorMessage {...{ errorAlert, errorMessage, errorTitle, onCloseErrorMessage }} />
      )}
      <View
        style={{ marginBottom }}
        className={`
          p-6 sm:p-0 bg-sky-white sm:px-14
          ${hideBorder ? "" : "border-t border-sky"}
          ${horizontalStyles[horizontalStyle]}
          ${verticalPadding}
        `}
      >
        <View className={`max-w-3xl mx-auto w-full ${horizontalStyles[horizontalStyle]}`}>{children}</View>
      </View>
    </View>
  );
}
